import React from "react";

const LABELS = {
  // F5.9 — CustomerOrder simplificada
  en_proceso:     "En Proceso",
  facturada:      "Facturada",
  // CustomerOrder legacy (mapean a En Proceso/Facturada via UI)
  registered:     "En Proceso",
  partial:        "En Proceso",
  complete:       "Facturada",
  delivered:      "Entregada",
  fabricating:    "Fabricando",
  listEntrega:    "Lista Entregar",
  // English DB values — WorkOrder
  pending:        "Pendiente",
  approved:       "Aprobada",
  working:        "Fabricando",
  ready:          "Lista",
  cancelled:      "Cancelada",  // F5.7
  // English DB values — Quotation (legacy)
  open:           "Cotizada",      // F5.8 — legacy alias
  sent:           "Enviada",
  rejected:       "Rechazada",
  revision:       "En Revisión",
  converted:      "Convertida",
  // F5.8 — nuevos estados Quotation
  cotizada:       "Cotizada",
  aprobada:       "Aprobada",
  terminada:      "Terminada",
  // Stock
  ok:             "Stock OK",
  none:           "Sin Stock",
  // Piece
  active:         "Activa",
  inactive:       "Inactiva",
};

// Map DB status values to CSS class suffixes defined in styles.css
const CSS_CLASS = {
  // F5.9 — CustomerOrder simplificada
  en_proceso:  "parcial",     // amber — activa hasta facturarse
  facturada:   "completo",    // verde — terminal con DTE
  // legacy
  registered:  "parcial",
  partial:     "parcial",
  complete:    "completo",
  delivered:   "entregada",
  fabricating: "en_fabricacion",
  listEntrega: "lista",
  pending:     "parcial",
  approved:    "aprobada",
  working:     "en_fabricacion",
  ready:       "lista",
  cancelled:   "rechazada",  // F5.7 — reusa el rojo/gris muted de rechazada
  open:        "abierta",
  sent:        "abierta",
  rejected:    "rechazada",
  revision:    "en_revision",
  converted:   "convertida",
  // F5.8 — Quotation lifecycle
  cotizada:    "abierta",      // morado — esperando decisión
  aprobada:    "aprobada",     // verde — en producción activa
  terminada:   "completo",     // verde oscuro — cerrada con doc
  ok:          "completo",
  none:        "sin_stock",
  active:      "aprobada",
  inactive:    "rechazada",
};

const StatusBadge = ({ status, label, prefix }) => {
  const cssKey = CSS_CLASS[status] || status || "parcial";
  const text = label ?? LABELS[status] ?? status;
  return (
    <span className={`bini-badge b-${cssKey}`}>
      {prefix ? `${prefix}: ${text}` : text}
    </span>
  );
};

export default StatusBadge;
